import CitiesBalancePage from './CitiesBalancePage';
export default CitiesBalancePage;
